// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__BQn60","col":"styles_col__2oIY3","fulfillmentStatus":"styles_fulfillmentStatus__3LK7U","emailCol":"styles_emailCol__3BpEn"};